// src/data/projectsData.js
const projectsData = [
    {
        id: 1,
        title: "Portfolio Template",
        description: "A single page portfolio template showcasing my skills and projects. Built with HTML, CSS, and JavaScript.",
        image: "./assets/projectImg/latestportfolio.png",
        liveDemo: "https://dhrubo256.github.io/tahmid-dhrubo",
        sourceCode: "https://github.com/Dhrubo256/tahmid-dhrubo",
        tags: ["HTML", "CSS", "Javascript"],
    },
    {
        id: 2,
        title: "Cafeino BD",
        description: "A commercial website for Cafeino BD, featuring a user-friendly interface and responsive design. Built with React JS and Bootstrap.",
        image: "./assets/projectImg/cafeino.png",
        liveDemo: "https://cafeino-bd.netlify.app",
        sourceCode: "https://github.com/Tahmid443/cafeino",
        tags: ["React JS", " Bootstrap", "CSS"],
    },
    {
        id: 3,
        title: "TikTakToe Game",
        description: "A simple Tic Tac Toe game built with React JS. Play against the computer in hard mode.",
        image: "./assets/projectImg/tiktaktoe.png",
        liveDemo: "https://tic-tac-tahmid.netlify.app",
        sourceCode: "https://github.com/Tahmid443/tic-tac-tahmid",
        tags: ["React JS", "JavaScript", "Bootstrap"],
    },
    {
        id: 4,
        title: "Free Palestine",
        description: "A simple website to raise awareness about muslim communities.",
        image: "./assets/projectImg/donate.png",
        liveDemo: "https://donate-palestine.netlify.app/",
        sourceCode: "https://github.com/Tahmid443/free_palestine",
        tags: ["React JS", "JavaScript", "Bootstrap"],
    },
    {
        id: 5,
        title: "Oxygen Gym",
        description: "A commercial website for Oxygen Gym, featuring a user-friendly interface and responsive design. Built with React JS and Bootstrap.",
        image: "./assets/projectImg/gym.png",
        liveDemo: "https://oxygen-gym-narsingdi.netlify.app/",
        sourceCode: "https://github.com/Tahmid443/oxygen-gym",
        tags: ["React JS", "JavaScript", "Bootstrap"],
    },
];

export default projectsData;